import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import BackgroundWrapper from '../../Global/Atomics/BackgroundWrapper';
import Box from '../../Global/Atomics/Box';
import { Container } from '../../Global/Atomics/Container';
import { Heading } from '../../Global/Atomics/Heading';
import { Paragraph } from '../../Global/Atomics/Paragraph';
import { NovaLogo } from '../../Global/Icons/Library';

import { useTranslationContext } from '../../../contexts/TranslationContext';

const AnimatedRow = styled(Row)`
    margin-top: 100px;
    animation: slide-out-top 2s cubic-bezier(0.215, 0.61, 0.355, 1) both;
    animation-delay: 1s;

    #nova-animated-logo {
        animation: resize 2s ease-out both;
        animation-delay: 1s;
    }

    @keyframes resize {
        0% {
            width: 230px;
            height: 101px;
        }
        100% {
            width: 92px;
            height: 40px;
        }
    }

    @keyframes slide-out-top {
        0% {
            opacity: 1;
        }
        100% {
            transform-origin: 0;
            margin-top: -100px;
            margin-bottom: 0px;
            opacity: 1;
        }
    }
`;

const AnimatedDiv = styled(Box)`
    animation: slide-to-top 2s cubic-bezier(0.215, 0.61, 0.355, 1) both;
    animation-delay: 1s;

    @keyframes slide-to-top {
        0% {
            transform: translateY(0%);
            opacity: 0.9;
        }
        100% {
            transform: translateY(72%);
            opacity: 1;
        }
    }
`;

const SplashScreen = () => {
    const { resources } = useTranslationContext();

    return (
        <BackgroundWrapper circleTop circleBottom height="100vh">
            <Container mt="lg" mb="md">

                {/* HIDDEN LOGO */}
                <Row as="header" between="xs" middle="xs" style={{ opacity: '0' }}>
                    <Col>
                        <Box ml="md" mb="lg" pb="sm">
                            <NovaLogo width={92} height={40} />
                        </Box>
                    </Col>
                </Row>

                {/* LOGO */}
                <AnimatedRow>
                    <Col>
                        <Box ml="md" mb="lg" mt="lg" pb="sm">
                            <NovaLogo id="nova-animated-logo" />
                        </Box>
                    </Col>
                </AnimatedRow>

                {/* WELCOME TEXT */}
                <Row>
                    <Col xs={7}>
                        <AnimatedDiv>
                            <Box ml="md">
                                <Heading level={1} typography="text-xl-light">{resources.title.welcomeToApp}</Heading>
                                <Heading level={1} typography="text-xl-bold" customColor="green-nova">{resources.title.smartCampusCampolide}</Heading>
                            </Box>
                            <Box ml="md" mt="sm" pt="xs">
                                <Paragraph typography="text-xs-medium">{resources.splashScreen.description}</Paragraph>
                            </Box>
                        </AnimatedDiv>
                    </Col>
                </Row>

            </Container>
        </BackgroundWrapper>
    );
};

export default SplashScreen;
